<div *ngIf="subnet">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>class</mat-icon>
      {{
        subnet.id ? "Subnet - " + subnet.name : "Create new Subnet"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ subnet.id ? "save" : "add" }}</mat-icon>
        {{ subnet.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="subnet.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Subnet Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [(companyId)]="subnet.companyId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="subnet.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>

          <tr>
            <th>
              <micro-valid-label
                for="vlanId"
                [model]="vlanId"
                label="Vlan ID"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #vlanId="ngModel"
                [(ngModel)]="subnet.vlanId"
                required
                maxlength="50"
                id="vlanId"
                name="vlanId"
              />
            </td>
          </tr>

          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="subnet.description"
                maxlength="200"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="network"
                [model]="network"
                label="Network"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #network="ngModel"
                [(ngModel)]="subnet.network"
                required
                maxlength="50"
                id="network"
                name="network"
              />
            </td>
          </tr>

          <tr>
            <th>
              <micro-valid-label
                for="subnet"
                [model]="subnetControl"
                label="Subnet"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #subnetControl="ngModel"
                [(ngModel)]="subnet.subnet"
                required
                maxlength="50"
                id="subnet"
                name="subnet"
              />
            </td>
          </tr>

          <tr>
            <th>
              <micro-valid-label
                for="subnetMask"
                [model]="subnetMask"
                label="Subnet Mask"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #subnetMask="ngModel"
                [(ngModel)]="subnet.subnetMask"
                required
                maxlength="50"
                id="subnetMask"
                name="subnetMask"
              />
            </td>
          </tr>

          <tr>
            <th>
              <micro-valid-label
                for="startIP"
                [model]="startIP"
                label="Start IP"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #startIP="ngModel"
                [(ngModel)]="subnet.startIP"
                required
                maxlength="50"
                id="startIP"
                name="startIP"
              />
            </td>
          </tr>

          <tr>
            <th>
              <micro-valid-label
                for="endIP"
                [model]="endIP"
                label="End IP"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #endIP="ngModel"
                [(ngModel)]="subnet.endIP"
                required
                maxlength="50"
                id="endIP"
                name="endIP"
              />
            </td>
          </tr>

          <tr>
            <th>
              <micro-valid-label
                for="gateway"
                [model]="gateway"
                label="Gateway"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #gateway="ngModel"
                [(ngModel)]="subnet.gateway"
                maxlength="10"
                id="gateway"
                name="gateway"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
